import * as React from "react"
import { storyblokEditable } from "gatsby-source-storyblok";
import TourTags from "./tourTags"
import TourPrice from "./tourPrice"

const LandingTourRow = ({ blok }) => {

  // console.log(blok)
  if (!blok.tour.content) return null;
  const content = blok.tour.content;
  const bannerBgImage = content.bannerBgImage?.filename ? content.bannerBgImage : null;
  // console.log(bannerBgImage)

  return (
    <div className="container max-w-screen-xl mx-auto md:flex" {...storyblokEditable(blok)} >
      <div className="md:w-1/2 p-8">
        <div className="text-lg mt-4 mb-2">{content.tourSubHeading}</div>
        <div className="text-3xl font-serif font-bold mb-4">{content.tourTitle}</div>
        <dd className="py-2 mb-4">{content.overviewHeading}</dd>
        <TourTags blok={content}/>
        <div className="price font-bold my-6"><TourPrice currency={content.currency} price={content.price} /></div> 
        <div className="details text-sm max-w-[500px]">
          <dl className="grid grid-cols-[auto,1fr]">
            <dt className="text-right font-bold p-2 border-black border-r ">Type</dt>
            <dd className="p-2 capitalize">{content.typeOfTour} Tour</dd>
            <dt className="text-right font-bold p-2 border-black border-r border-y bg-gray-100">Duration</dt>
            <dd className="p-2 border-black border-y bg-gray-100">{content.durationDays} {content.durationDays <= 1 ? 'Day' : 'Days'}{content.durationNights && `, ${content.durationNights} ${content.durationNights <= 1 ? 'Night' : 'Nights'}`}</dd>
            
          </dl>
        </div>
        <a href={`/${blok.tour.full_slug}`} className="">
          <button className="text-lg text-blue-700 border-2 border-blue-700 rounded-lg py-2 px-8 mt-10 flex items-center">
          Plan Your Trip Now
            <img className="w-8 h-3 align-middle ml-4" src="/icons/arrow-right-blue.svg" alt="Arrow right"/>
          </button>
        </a>
      </div>
      <div className="md:w-1/2 p-8">
        <img className="w-full rounded object-cover" alt={bannerBgImage?.alt} loading="lazy" src={`${bannerBgImage?.filename}/m/`} />
      </div>
    </div>
    )
}

export default LandingTourRow
